/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum to store the various UX interaction events.
 */
export var InteractionEventSubType;
(function (InteractionEventSubType) {
    InteractionEventSubType["EXPAND_PRD_SECTION"] = "expand_prd_section";
    InteractionEventSubType["COLLAPSE_PRD_SECTION"] = "collapse_prd_section";
    InteractionEventSubType["CLICK_PRD_DIAGRAM_NODE"] = "click_prd_diagram_node";
    InteractionEventSubType["CLICK_PRD_LINK"] = "click_prd_link";
    InteractionEventSubType["CLICK_PRD_GO_TO_APP_BUTTON"] = "click_prd_go_to_app_button";
    InteractionEventSubType["CLICK_RUN_APP_BUTTON"] = "click_run_app_button";
    InteractionEventSubType["PRD_EDIT"] = "prd_edit";
    InteractionEventSubType["PRD_COMMENT"] = "prd_comment";
    InteractionEventSubType["CLICK_NEW_VERSION"] = "click_new_version";
})(InteractionEventSubType || (InteractionEventSubType = {}));
